import styled from 'styled-components';
import theme from 'modules/financial/pages/GeneralView/theme';

export const UploadSectionTitle = styled.h2`
  font-size: 0.875rem;
  font-weight: 500;
  color: ${({ theme }) => theme.primary};
  margin: 0;
`;

export const UploadSectionDescription = styled.p`
  font-size: 0.875rem;
  color: ${theme.colors.lightText};
  font-weight: 500;
  margin: 0;
`;

export const RadioLabel = styled.p`
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 8px;
`;
